import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DynamicBuilderUtil } from '../../../utils/';
import { AtxModalComponent } from './atx-modal.component';

@Component({
    template: `<div class="modal-header">
    <h4 class="modal-title"
        *ngIf="title">
        {{ title }}
    </h4>
    <button type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal()">
    </button>
</div>
<div class="modal-body mt-0">
    <div class="container-fluid p-0">
        <div #container></div>
    </div>
</div>
<div class="modal-footer"
     *ngIf="hasFooter">
    <button type="button"
            class="btn btn-outline-dark"
            (click)="closeModal()">
        {{ 'common.label.close' }}
    </button>
    <button type="button"
            class="btn btn-outline-dark"
            (click)="acceptModal()">
        {{ 'common.label.submit' }}
    </button>
</div>
`,
    providers: [
        DynamicBuilderUtil
    ]
})

export class AtxModalBuilderComponent extends AtxModalComponent implements OnInit {
    @Input('template') template;

    constructor(
        private dynamicBuilderUtil: DynamicBuilderUtil,
        private activeModal: NgbActiveModal,
    ) {
        super(activeModal);
    }

    ngOnInit() {
        super.ngOnInit();

        const factory = this.dynamicBuilderUtil.createComponentFactorySync(this.template);

        this.componentRef = this.container.createComponent(factory);
        (<any>this.componentRef.instance).data = this.options;
    }
}
